<template>
  <div class="admin-login">
    <a :href="config.homepageURL" target="_blank">
      <HMLogo class="logo" />
    </a>
    <div class="container">
      <div class="d-flex align-items-center justify-content-center">
        <HMModalContainer class="flex-shrink-1 admin-login-wrapper">
          <Login
            class="pb-2"
            @onResetPassword="
              () => $router.push({ name: 'admin-get-reset-password' })
            "
            @onLogin="onLogin"
          />
          <hr class="mt-4 mb-4" />
          <div>
            <span>
              {{ $t('GENERAL.LABEL.WANT_TO_TEACH', { applicationName }) }}
            </span>
            <a :href="config.homepageURL" target="_blank">
              {{ $t('GENERAL.LINK.LEARN_MORE') }}
            </a>
          </div>
        </HMModalContainer>
      </div>
    </div>
  </div>
</template>

<script>
import Login from '@/web/components/signup/Login.vue';
import { getConfig } from '@/web/utils/configuration';
import * as analytics from '@/web/services/analytics';
import { mapGetters } from 'vuex';

export default {
  name: 'AdminLogin',
  components: {
    Login,
  },
  computed: {
    ...mapGetters({
      userId: 'user/userId',
    }),
    config() {
      return getConfig();
    },
    applicationName() {
      return this.config.applicationName;
    },
  },
  methods: {
    onLogin() {
      analytics.login(this.userId);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/web/styles/components-variables.scss';

.admin-login {
  background-position: top left, bottom right;
  background-repeat: no-repeat;
  background-image: url('~@/assets/images/blob-up.svg'),
    url('~@/assets/images/blob-down.svg');
  background-size: 200px auto, 420px auto;
  @include media-breakpoint-up(md) {
    background-size: 340px auto, 520px auto;
  }
}

.admin-login-wrapper {
  border: 1px solid $lightest-gray;
  margin-bottom: 60px;

  @include media-breakpoint-up(md) {
    box-shadow: 0 16px 24px rgba(0, 0, 0, 0.07);
    border-radius: $border-radius;
  }
}

::v-deep .modal-wrapper {
  background-color: $white !important;
}
.login-side-image {
  max-width: 40%;
}
.logo {
  height: 17px;
  margin: 2rem;
}
::v-deep .login h1 {
  font-weight: 700;
}
::v-deep .hm-modal-header {
  display: none !important;
}
</style>
